<div class="marketing-sheet-photos">
  <!-- Header -->
  <div class="photos-header" *ngIf="showHeader">
    <h3 class="photos-title">{{ title }}</h3>
    <span class="material-number-badge" *ngIf="materialNumber">{{ materialNumber }}</span>
    <div class="photos-header-actions">
      <button kendoButton [look]="'flat'" (click)="refresh()" title="Refresh" [disabled]="isLoading">
        <span class="k-icon k-font-icon k-i-reload"></span>
      </button>
      <button kendoButton [look]="'flat'" (click)="toggleUploadMode()" *ngIf="allowUpload" title="Upload new photos">
        <span class="k-icon k-font-icon k-i-upload"></span>
        {{ showUploader ? 'Cancel' : 'Upload' }}
      </button>
    </div>
  </div>

  <!-- Upload mode -->
  <div class="upload-section" *ngIf="showUploader && allowUpload">
    <div class="upload-slots">
      <div class="upload-slot" *ngFor="let slot of ['side', 'top']">
        <label class="upload-slot-label">{{ slot === 'top' ? 'Top View' : 'Side View' }}</label>
        <div class="upload-drop-area" [class.has-file]="uploadFiles[slot]">
          <input type="file" accept=".jpg,.jpeg,.png" (change)="onFileSelected($event, slot)"
            class="upload-file-input" />
          <div class="upload-drop-content" *ngIf="!uploadFiles[slot]">
            <span class="k-icon k-font-icon k-i-upload"></span>
            <span>Click or drag to select {{ slot }} image</span>
            <span class="upload-hint">.jpg, .jpeg, .png</span>
          </div>
          <div class="upload-file-selected" *ngIf="uploadFiles[slot]">
            <span class="k-icon k-font-icon k-i-check-circle"></span>
            <span>{{ uploadFiles[slot]?.name }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="upload-actions">
      <button kendoButton (click)="toggleUploadMode()">Cancel</button>
      <button kendoButton themeColor="primary" (click)="uploadPhotos()" [disabled]="!hasFilesToUpload() || isUploading">
        <span *ngIf="isUploading">
          <kendo-loader size="small" themeColor="light"></kendo-loader>
          Uploading...
        </span>
        <span *ngIf="!isUploading">
          <span class="k-icon k-font-icon k-i-upload"></span>
          Upload Photos
        </span>
      </button>
    </div>
  </div>

  <!-- Photo display -->
  <div class="photos-grid" *ngIf="!showUploader">
    <!-- Global loading overlay -->
    <div class="photos-loading" *ngIf="isLoading && !photos[0]?.imageUrl">
      <kendo-loader type="infinite-spinner" size="large"></kendo-loader>
      <p>Loading photos...</p>
    </div>

    <div *ngFor="let photo of photos" class="photo-card" [class.has-image]="!!photo.imageUrl"
      [class.loading]="photo.isLoading">
      <label class="photo-label">{{ photo.label }}</label>

      <!-- Image loaded -->
      <div class="photo-image-container" *ngIf="photo.imageUrl && !photo.isLoading && !photo.error">
        <img [src]="photo.imageUrl" [alt]="photo.label + ' - ' + materialNumber" class="photo-image"
          (click)="onPhotoClick(photo)" />
        <div class="photo-overlay">
          <span class="photo-filename" *ngIf="photo.fileName">{{ photo.fileName }}</span>
          <div class="photo-actions">
            <button kendoButton [look]="'flat'" size="small" (click)="downloadPhoto(photo)" title="Download">
              <span class="k-icon k-font-icon k-i-download"></span>
            </button>
            <button kendoButton [look]="'flat'" size="small" (click)="onPhotoClick(photo)" title="View full size">
              <span class="k-icon k-font-icon k-i-zoom"></span>
            </button>
          </div>
        </div>
      </div>

      <!-- Loading state per slot -->
      <div class="photo-placeholder loading" *ngIf="photo.isLoading">
        <kendo-loader type="infinite-spinner" size="medium"></kendo-loader>
        <span>Loading...</span>
      </div>

      <!-- Empty state -->
      <div class="photo-placeholder empty" *ngIf="!photo.imageUrl && !photo.isLoading && !photo.error">
        <span class="k-icon k-font-icon k-i-image" style="font-size: 48px;"></span>
        <span>No {{ photo.label.toLowerCase() }} uploaded</span>
        <button kendoButton size="small" *ngIf="allowUpload" (click)="toggleUploadMode()">
          <span class="k-icon k-font-icon k-i-upload"></span> Upload
        </button>
      </div>

      <!-- Error state -->
      <div class="photo-placeholder error" *ngIf="photo.error && !photo.isLoading">
        <span class="k-icon k-font-icon k-i-warning-triangle" style="font-size: 48px;"></span>
        <span class="error-text">{{ photo.error }}</span>
        <button kendoButton size="small" (click)="retryPhoto(photo)">
          <span class="k-icon k-font-icon k-i-reload"></span> Retry
        </button>
      </div>
    </div>
  </div>

  <!-- Full-size viewer overlay -->
  <div class="photo-viewer-overlay" *ngIf="viewerPhoto" (click)="closeViewer()">
    <div class="photo-viewer-content" (click)="$event.stopPropagation()">
      <div class="viewer-header">
        <span>{{ viewerPhoto.label }} — {{ materialNumber }}</span>
        <button kendoButton [look]="'flat'" (click)="closeViewer()">
          <span class="k-icon k-font-icon k-i-close"></span>
        </button>
      </div>
      <img [src]="viewerPhoto.imageUrl" [alt]="viewerPhoto.label" class="viewer-image" />
    </div>
  </div>
</div>
